import {PrincipalFavoritePlaceEnum} from 'domain/usecases/private/guide-flow/medical-guide/get-favorite-places';
import {formatAddress} from 'presentation/utils';
import {
	IsAddressAlreadySavedParams,
	FormatReverseGeocodeAddressLabelParams,
	FavoritePlaceToAddressFormParserParams,
} from './types';

function normalizeAddressText(value: string | null | undefined): string {
	return (value ?? '').trim().toLowerCase();
}

function isAddressAlreadySaved({
	street,
	city,
	state,
	cep,
	list,
}: IsAddressAlreadySavedParams): boolean {
	const normalizedCep = (cep ?? '').replace(/\D/g, '');

	return list.some(item => {
		const savedCep = (item.address.nuCep ?? '').replace(/\D/g, '');

		if (normalizedCep && savedCep && normalizedCep === savedCep) {
			return true;
		}

		return (
			normalizeAddressText(street) === normalizeAddressText(item.address.nmLogradouro) &&
			normalizeAddressText(city) === normalizeAddressText(item.address.nmCidade) &&
			normalizeAddressText(state) === normalizeAddressText(item.address.nmUf)
		);
	});
}

function formatReverseGeocodeAddressLabel({
	reverseGeocodeData,
}: FormatReverseGeocodeAddressLabelParams): string {
	if (!reverseGeocodeData) return '';

	return formatAddress({
		address: reverseGeocodeData.street ?? '',
		number: reverseGeocodeData.number ?? '',
		city: reverseGeocodeData.city ?? '',
		state: reverseGeocodeData.state ?? '',
	});
}

function favoritePlaceToAddressFormParser({item}: FavoritePlaceToAddressFormParserParams) {
	if (!item) return null;

	const {nmLocal} = item.address;
	const nmTipoLogradouro = item.address.nmLogradouro.split(' ')[0];
	const nmRua = item.address.nmLogradouro.split(' ').slice(1).join(' ');

	return {
		favoriteAddress: nmLocal,
		cdUsuario: '',
		cdEnderecoCorrespondencia: 1,
		cdEnderecoCorrespondenciaUt: 1,
		nmTipoLogradouro,
		nmRua,
		dsPontoReferencia: '',
		flTipoEndereco: '',
		dsComplemento: item.address?.dsComplemento || '',
		...item.address,
		flPrincipal: item.address.flPrincipal === PrincipalFavoritePlaceEnum.YES,
	};
}

export {favoritePlaceToAddressFormParser, formatReverseGeocodeAddressLabel, isAddressAlreadySaved};
